import _ from '../../core/utils'

const HINT_CONFIG = {
    hint: _.select( '.fl__hint' ),
    message: _.select( '.fl__hint p' ),
    status: {
        success: 'fl__hint--success',
        error: 'fl__hint--error'
    },
    timeout: 5000
}

export default HINT_CONFIG